module.exports = __webpack_public_path__ + "static/media/icon-marketplace.448c3c4e.svg";